import React, { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { SimpleToggleTW } from 'tailwindComponents/toggleTW/SimpleToggleTW';
import { ISettlementItemForm, createDefaultSettlementItemForm } from 'types/order/fees/ICreateSettlementItemForm';
import { useGetCurrentLineItem } from '../edit/useGetCurrentLineItem';
import { useLineItemSave } from '../edit/useLineItemSave';
import { eFeePropertyNames } from 'types/order/fees/eFeePropertyNames';

export interface INettedOutProps {
  columnValue?: string;
  lineItemId?: string;
  sectionDefinitionId?: string;
}

export const NettedOut: React.FC<INettedOutProps> = ({ columnValue, sectionDefinitionId, lineItemId }) => {
  const { orderId, feeId } = useParams<{ orderId: string; feeId?: string }>();
  const value = ['true', 'TRUE'].includes(columnValue ?? '');
  const [currentValue, setCurrentValue] = useState<boolean>(value);

  const isDisabled = !!feeId;

  const lineItem = useGetCurrentLineItem({
    orderId,
    sectionDefinitionId,
    lineItemId,
  });
  const lineItemForm = useMemo(
    () => createDefaultSettlementItemForm(sectionDefinitionId, lineItem),
    [sectionDefinitionId, lineItem]
  );
  const onSave = useLineItemSave({ orderId });

  useEffect(() => {
    if (value !== currentValue && !isDisabled) {
      const lineItemToSave: ISettlementItemForm = {
        ...lineItemForm,
        statementFees: lineItemForm.statementFees.map((t) => ({
          ...t,
          stringFeePropertyValues: {
            ...t.stringFeePropertyValues,
            [eFeePropertyNames.NettedOut]: currentValue ? 'true' : 'false',
          },
        })),
      };
      onSave(lineItemToSave);
    }
    if (value !== currentValue && isDisabled) {
      setCurrentValue(value);
    }
  }, [value, currentValue, lineItemForm, onSave, isDisabled]);

  return (
    <SimpleToggleTW
      readOnly={isDisabled}
      className={''}
      text={''}
      checked={currentValue}
      onChange={setCurrentValue}
      data-test-id={'netted-out-toggle'}
    />
  );
};
